<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <div class="flex a-center j-center" style="height: 60px;">
      <span class="bold fs-16">分享设置</span>
    </div>

    <div class="flex-column a-center j-center" style="width: 550px;">
      <div class="h-400" style="position: relative;width:450px;height: 360px;">
        <up-load-image @uploadSuccess="onUploadShareCoverSuccess($event)" accept="image/*"
                       picurl="platform/icon/module/"
                       style="width:450px;">
          <template v-slot:tip>
            <div style="width: 450px; position: relative;left: 0;top: 0">
              <div class="flex-column a-center j-center"
                   style="width: 450px;height: 360px;background-color: #F6F9FF;cursor: pointer">
                <img alt="" src="../../../../assets/common/ic_upload_picture@2x.png"
                     style="width: 96px;height: 96px">
                <span class="m-t-5  color-66">上传图片</span>
              </div>

              <img :src="editData.shareCover" @click.stop=""
                   style="position: absolute;width: 450px;height: 360px;left: 0;top: 0;background-color: #F6F9FF;"
                   v-if="editData.shareCover"/>

              <img @click.stop="onDelShareCoverSuccess()"
                   src="../../../../assets/common/ic_yichu.png"
                   style="position: absolute;right: -11px;top: -11px" v-if="editData.shareCover"/>
            </div>
          </template>
        </up-load-image>
      </div>
      <Input class="m-t-20 m-b-10" placeholder="分享标题" style="width: 450px"
             v-model="editData.shareTitle"/>

      <div
        class="m-b-10 flex m-v-10"
        style="width: 450px"
      >
        <span class="fs-14  w-90">分享按钮：</span>
        <RadioGroup class="w-full flex" v-model="editData.showShareBtn">
          <radio :label="1" size="small" class="m-r-10">
            <span class="fs-14 ">显示</span>
          </radio>
          <radio :label="0" size="small" class="m-r-10">
            <span class="fs-14 ">隐藏</span>
          </radio>
        </RadioGroup>
      </div>

    </div>

    <div class="flex a-center j-center" style="height: 60px;background-color: #F7F9FD">
      <Button @click="shareSettingCancel" class="m-r-10">取消</Button>
      <Button @click="shareSettingOk" class="m-l-10">确定</Button>
    </div>

  </div>
</template>

<script>
import UpLoadImage from '../../../../components/common/UpLoadImage'
import {mapActions} from 'vuex'

export default {
  name: 'SharePageSettingWidget',
  components: {UpLoadImage},
  props: {
    editData: {
      type: Object,
      default: () => {
        return {
          editPageId: 0,
          shareCover: '',
          shareTitle: '',
          showShareBtn:0,
          extension: null,
        }
      }
    }
  },
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    shareSettingCancel () {
      this.$emit('cancel')
    },
    shareSettingOk () {
      let pageConfig = this.editData

      if (pageConfig.extension == null) {
        pageConfig.extension = {showShareBtn:pageConfig.showShareBtn}
      }else{
        pageConfig.extension.showShareBtn = pageConfig.showShareBtn
      }

      let params = {
        shareTitle: pageConfig.shareTitle || '',
        shareCover: pageConfig.shareCover || '',
        extension:  JSON.stringify(pageConfig.extension)
      }
      this.editPageBase({
        id: this.editData.editPageId,
        params
      }).then(res => {
        if (res.code === 0) {
          this.$emit('config')
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },
    onUploadShareCoverSuccess (data) {            //分享设置上传图片成功
      if (data && data.length) {
        this.editData.shareCover = data[0].url
      }
    },
    onDelShareCoverSuccess () {                   //分享设置删除图片
      this.editData.shareCover = ''
    },

    ...mapActions([
      'getPageDetail',
      'editPageBase'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
